/**
 * @file 其他工具类
 */
export default {
    /**
     * 更新一个对象的值,并返回一个新的对象
     *
     * @private
     * @param {Object} oldObj 被更新的对象
     * @param {Object} newObj 需要更新的值
     * @return {Object} finalObj 新对象
     */
    mergeObject: (oldObj, newObj) => {
        const finalObj = {};
        Object.keys(oldObj).map(item => {
            if (oldObj[item]) {
                finalObj[item] = newObj[item] ? newObj[item] : oldObj[item];
            }
            return false;
        });

        Object.keys(newObj).map(item => {
            if (newObj[item] && !oldObj[item]) {
                finalObj[item] = newObj[item];
            }
            return false;
        });

        return finalObj;
    },

    /**
    * 判断变量是否为一个对象
    *
    * @private
    * @param {Object} obj 需要进行判断的变量
    * @return  {boolean}
    */
    isObject: obj => {
        if (!obj) {
            return false;
        }
        return Object.prototype.toString.call(obj) === '[object Object]';
    }
};
